import { IconButton, Stack } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';
import ReplayIcon from '@mui/icons-material/Replay';
import { StartEndTimeProps } from '../../AnomaliesSidebar.types';
import { Time } from './Time';

export function StartEndTime(props: StartEndTimeProps) {
  const { start, end, isReplayButton, onSeekChange } = props;
  return (
    <Stack direction='row' gap={1} justifyContent='space-between'>
      <Time time={start} />
      <Time
        time={end}
        customIcon={<UpdateIcon sx={{ transform: 'scale(0.8)' }} opacity={0.8} fontSize='small' />}
      />
      {isReplayButton && (
        <IconButton sx={{ height: 20 }} onClick={() => onSeekChange(start)}>
          <ReplayIcon fontSize='small' />
        </IconButton>
      )}
    </Stack>
  );
}
